import { render, staticRenderFns } from "./TransactionTurnstile.vue?vue&type=template&id=1459ac4c&scoped=true"
import script from "./TransactionTurnstile.vue?vue&type=script&lang=js"
export * from "./TransactionTurnstile.vue?vue&type=script&lang=js"
import style0 from "./TransactionTurnstile.vue?vue&type=style&index=0&id=1459ac4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1459ac4c",
  null
  
)

export default component.exports